(function () {
  var selector = '[data-rision-c-slider]';

  function init(root) {
    if (!root || root.getAttribute('data-rision-c-ready') === 'true') return;

    var track = root.querySelector('[data-rision-c-track]');
    var origSlides = Array.prototype.slice.call(root.querySelectorAll('[data-rision-c-slide]'));
    var prev = root.querySelector('[data-rision-c-prev]');
    var next = root.querySelector('[data-rision-c-next]');
    if (!track || origSlides.length <= 1) return;

    root.setAttribute('data-rision-c-ready', 'true');

    var origCount = origSlides.length;
    var desktopCount = parseInt(root.getAttribute('data-visible'), 10) || 1;
    var cloneCount = desktopCount;

    for (var i = 0; i < cloneCount; i++) {
      var tailSlide = origSlides[i % origCount].cloneNode(true);
      tailSlide.setAttribute('data-rision-c-clone', 'tail');
      track.appendChild(tailSlide);

      var headIdx = (origCount - 1 - (i % origCount) + origCount) % origCount;
      var headSlide = origSlides[headIdx].cloneNode(true);
      headSlide.setAttribute('data-rision-c-clone', 'head');
      track.insertBefore(headSlide, track.firstChild);
    }

    var allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-rision-c-slide]'));
    var currentIndex = cloneCount;
    var isAnimating = false;

    function gapSize() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    function getOffset(idx) {
      var slideWidth = allSlides[0].getBoundingClientRect().width;
      return idx * (slideWidth + gapSize());
    }

    function setPosition(idx, withTransition) {
      track.style.transition = withTransition ? '' : 'none';
      var offset = getOffset(idx);
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      if (!withTransition) {
        track.offsetHeight;
      }
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      isAnimating = false;

      if (currentIndex >= origCount + cloneCount) {
        currentIndex -= origCount;
        setPosition(currentIndex, false);
      } else if (currentIndex < cloneCount) {
        currentIndex += origCount;
        setPosition(currentIndex, false);
      }
    });

    if (prev) {
      prev.classList.remove('is-disabled');
      prev.disabled = false;
      prev.setAttribute('aria-disabled', 'false');
      prev.addEventListener('click', function () {
        if (isAnimating) return;
        isAnimating = true;
        currentIndex -= 1;
        setPosition(currentIndex, true);

        prev.classList.add('is-active');
        if (next) next.classList.remove('is-active');
      });
    }

    if (next) {
      next.classList.remove('is-disabled');
      next.classList.add('is-active');
      next.disabled = false;
      next.setAttribute('aria-disabled', 'false');
      next.addEventListener('click', function () {
        if (isAnimating) return;
        isAnimating = true;
        currentIndex += 1;
        setPosition(currentIndex, true);

        next.classList.add('is-active');
        if (prev) prev.classList.remove('is-active');
      });
    }

    window.addEventListener('resize', function () {
      setPosition(currentIndex, false);
    });

    setPosition(currentIndex, false);
  }

  function scan(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, init);
  }

  document.addEventListener('DOMContentLoaded', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scan(document);
  }
})();